import {FetchedTheme, FetchedThemeElements} from "@/types/theme";
import { snapshot } from "valtio";
import store from "@/store";

const themeSaveMapper = (single?: boolean):FetchedTheme => {
    const { currentUser, selectedTheme } = snapshot(store);
    const { selectedElementId, currentElements, originalElements } = selectedTheme;

    const currentMainCss = currentElements.find(el => el.name === 'Main Css');
    const originalMainCss = originalElements.find(el => el.name === 'Main Css');

	const currentTourSteps = currentElements.find(el => el.name === 'Tour Steps');
    const originalTourSteps = originalElements.find(el => el.name === 'Tour Steps');


	console.log(currentElements);


    const css =
        single && currentMainCss?.id !== selectedElementId
            ? originalMainCss?.css || ''
            : currentMainCss?.css || '';

	const tourSteps =
		single && currentTourSteps?.id !== selectedElementId
			? originalTourSteps?.jsx || ''
			: currentTourSteps?.jsx || '';

    const elements = (single
        ? currentElements?.filter(el => el.id === selectedElementId && el.status !== 'deleted')
        : currentElements?.filter(el => el.status !== 'deleted'))?.reduce((acc, el) => {
        if (el.name !== 'Main Css' && el.name !== 'Tour Steps') {
            const original = originalElements.find(ori => ori.name === el.name);
            const noteSame = el.note === original?.note;
            const hintsSame = JSON.stringify(el.hints) === JSON.stringify(original?.hints);

            acc[el.name] = {
                css: el.css || '',
                jsx: el.jsx || '',
                mobileCss: el.mobileCss || '',
                tabletCss: el.tabletCss || '',
                note: noteSame ? undefined : el.note || '',
                hints: hintsSame ? null : el.hints?.slice() || [],
                status: "saved" satisfies FetchedThemeElements["status"],
                update: {
                    user: currentUser?.nickname,
                    email: currentUser?.email,
                    time: new Date().toISOString()
                }
            };
        }
        return acc;
    }, {} as Record<string, FetchedTheme['theme']['elements'][string]>);

    if (single) {
        originalElements.filter((el)=> el.status !== "deleted").forEach(el => {
            if (el.name !== 'Main Css' && el.name !== 'Tour Steps' && !elements[el.name]) {
                elements[el.name] = {
                    css: el.css || '',
                    jsx: el.jsx || '',
                    mobileCss: el.mobileCss || '',
                    tabletCss: el.tabletCss || '',
                    note: el.note || '',
                    hints: el.hints?.slice() || [],
                    status: 'saved' satisfies FetchedThemeElements["status"],
                    update: null
                };
            }
        });
    }

    return {
        id: selectedTheme.id,
        title: selectedTheme.title,
        theme: {
            css,
	        tourSteps,
            elements
        }
    };
};

export default themeSaveMapper;
